const getRegion = (city: string | null | undefined, region: string | null | undefined) =>
  city && region ? `${decodeURIComponent(city)}, ${region}` : city || region;

export default getRegion;
